import { AddCircle, KeyboardArrowUp } from "@mui/icons-material";
import { Card, CardContent, Typography } from "@mui/material";

const QuickActions = ({ setDrawerOpen }: { setDrawerOpen: (open: boolean) => void }) => {
  return (
    <Card
      className="rounded-2xl"
      sx={{ border: "1px solid #e5e5e5", boxShadow: "none" }}
      onClick={() => setDrawerOpen(true)}
    >
      <CardContent className="flex items-center gap-3">
        <AddCircle className="text-primary-active size-8" />
        <Typography variant="h6" className="font-semibold mt-1">
          Quick Actions
        </Typography>
        <KeyboardArrowUp className="ml-auto" />
      </CardContent>
    </Card>
  );
};

export default QuickActions;
